export default __webpack_public_path__ + "static/media/bi.fa653f3c.svg";